import React from 'react';
import { LoginForm } from '@features/auth/components/login-form/LoginForm';

import { W2AuthChrome } from './W2AuthChrome';
import { useW2FlowContext } from './W2FlowLayout';
import { useW2Paths } from './paths';

export const W2LoginRoute: React.FC = () => {
  const { runEnroll } = useW2FlowContext();
  const paths = useW2Paths();
  return (
    <W2AuthChrome>
      <LoginForm
        onAuthenticated={runEnroll}
        forgotPasswordPath={paths.forgot}
        registrationPath={paths.register}
      />
    </W2AuthChrome>
  );
};
